'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';
import Link from 'next/link';
import Image from 'next/image';

const PHONE_HREF = 'tel:09844068955';
const PHONE = '098440 68955';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header data-component-id="src/components/Header.tsx:21:4" data-component-path="src/components/Header.tsx" data-component-line="21" data-component-end-line="52" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%7D"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-sm border-b border-border py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div data-component-id="src/components/Header.tsx:28:6" data-component-path="src/components/Header.tsx" data-component-line="28" data-component-end-line="51" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22section-padding%20max-w-7xl%20mx-auto%20flex%20items-center%20justify-between%22%7D" className="section-padding max-w-7xl mx-auto flex items-center justify-between">

        {/* Logo */}
        <Link data-component-id="src/components/Header.tsx:31:8" data-component-path="src/components/Header.tsx" data-component-line="31" data-component-end-line="40" data-component-file="Header.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2F%22%2C%22className%22%3A%22flex%20items-center%20mx-auto%20lg%3Amx-0%22%7D" href="/" className="flex items-center mx-auto lg:mx-0">
          <Image data-component-id="src/components/Header.tsx:32:10" data-component-path="src/components/Header.tsx" data-component-line="32" data-component-end-line="39" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%2Fassets%2Fimages%2Faom-logo.png%22%2C%22alt%22%3A%22Asian%20Office%20Maker%20Logo%22%2C%22className%22%3A%22lg%3Aw-%5B300px%5D%20h-auto%22%7D"
            src="/assets/images/aom-logo.png"
            alt="Asian Office Maker Logo"
            width={220}   // mobile size
            height={110}
            priority
            className="lg:w-[300px] h-auto" // bigger on desktop
          />
        </Link>

        {/* Desktop CTA only */}
        <div data-component-id="src/components/Header.tsx:43:8" data-component-path="src/components/Header.tsx" data-component-line="43" data-component-end-line="49" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22hidden%20lg%3Aflex%20items-center%20gap-4%22%7D" className="hidden lg:flex items-center gap-4">
          

          <a data-component-id="src/components/Header.tsx:46:10" data-component-path="src/components/Header.tsx" data-component-line="46" data-component-end-line="48" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%5Bvar%3APHONE_HREF%5D%22%2C%22className%22%3A%22btn-primary%20py-2.5%20px-6%20text-sm%22%2C%22textContent%22%3A%22Call%3A%20098440%2068955%22%7D" href={PHONE_HREF} className="btn-primary py-2.5 px-6 text-sm">
            Call: 098440 68955
          </a>
        </div>

      </div>
    </header>
  );
}